export const isRedeemCodePage = window.location.hash.includes('application/redeemcode');